import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { RxDashboard } from "react-icons/rx";
import { IoDocumentsOutline } from "react-icons/io5";
import { FaReceipt } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import { IoMdSettings } from "react-icons/io";
import { IoLogOutSharp } from "react-icons/io5";
import { MdDescription } from "react-icons/md";
import { PiUserPlusFill } from "react-icons/pi";
import { MdLiveHelp } from "react-icons/md";
import Cookies from "js-cookie";
import logo from "../images/litax_logo.png";
import { useYearContext } from "../../admin/components/YearContext";

const Clientsidebar = ({ openSidebarToggle, openSidebar }) => {
  const navigate = useNavigate();
  const { clearYearFromLocalStorage } = useYearContext();

  const handleLogout = () => {
    Cookies.remove("token");
    localStorage.removeItem("role");
    clearYearFromLocalStorage();

    navigate("/login");
  };
  return (
    <aside
      id="invoice-sidebar"
      className={openSidebarToggle ? "sidebar-responsive" : ""}
    >
      <div className="sidebar-title">
        <div className="sidebar-brand d-flex gap-2  align-items-center">
          <img src={logo} className="w-25 h-25" />
          <h5>Litax</h5>
        </div>
        <span className="icon close_icon" onClick={openSidebar}>
          X
        </span>
      </div>

      <ul className="sidebar-list">
        <li className="sidebar-list-item">
          <NavLink
            to="/client"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <RxDashboard size={18} className="me-3" />
            Dashboard
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/taxorganizer"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <MdDescription size={18} className="me-3" />
            Tax Organizer
          </NavLink>
        </li>
        
        <li className="sidebar-list-item">
          <NavLink
            to="/documents"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <IoDocumentsOutline size={18} className="me-3" />
            Documents
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/clientreferandearn"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <PiUserPlusFill size={18} className="me-3" />
            Refer And Earn
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/clientinvoices"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <FaReceipt size={18} className="me-3" />
            Invoices
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/clientprofile"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <CgProfile size={18} className="me-3" />
            My Profile
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/settings"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <IoMdSettings size={18} className="me-3" />
            Settings
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/helpcenter"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <MdLiveHelp size={18} className="me-3" />
            HelpCenter
          </NavLink>
        </li>

        <div className="sidebar-list-item" onClick={handleLogout}>
          <IoLogOutSharp size={18} className="me-3" />
          Logout
        </div>
      </ul>
    </aside>
  );
};

export default Clientsidebar;
